import * as React from "react";
import styled from "styled-components";
import Icon from "components/common/Icon";
import Menu from "./Menu";
import Button from "./Button";
const StyledIcon = styled(Icon)`
  width: 10px;
  height: 10px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const position = (pullRight, dropup) => {
  const orientation = dropup ? "top" : "bottom";
  const suffix = pullRight ? "-end" : "";
  return `${orientation}${suffix}`;
};
const DropdownButton = ({
  buttonTitle = void 0,
  children = void 0,
  closeOnItemClick = true,
  dropup = void 0,
  title = void 0,
  onMouseDown = void 0,
  onToggle = void 0,
  pullRight = void 0,
  noCaret = void 0,
  keepMounted = void 0,
  withinPortal = void 0,
  ...rest
}) => /* @__PURE__ */ React.createElement(
  Menu,
  {
    position: position(pullRight, dropup),
    onChange: onToggle,
    keepMounted,
    closeOnItemClick,
    withinPortal
  },
  /* @__PURE__ */ React.createElement(Menu.Target, null, /* @__PURE__ */ React.createElement(Button, { onClick: onMouseDown, "aria-label": buttonTitle, ...rest, title: buttonTitle }, title, noCaret ? null : /* @__PURE__ */ React.createElement(React.Fragment, null, " ", /* @__PURE__ */ React.createElement(StyledIcon, { name: "arrow_drop_down" })))),
  /* @__PURE__ */ React.createElement(Menu.Dropdown, null, children)
);
export default DropdownButton;
